/**
 * URL 白名单域名列表
 * 支持通配符匹配，如 *.wps.cn 匹配所有 wps.cn 的子域名
 */
const ALLOWED_DOMAINS = ['*.wps.cn', '*.wpscdn.cn', '*.kdocs.cn', '*.wps.com'];

/**
 * 验证 URL 是否在白名单域名中
 * @param url 待验证的 URL 字符串
 * @returns 是否通过验证
 */
export const isUrlAllowed = (url: string): boolean => {
  try {
    // 1. 校验是否为标准的 URL 格式
    const urlObj = new URL(url);

    // 2. 只允许 http 和 https 协议，防止 javascript:、data: 等危险协议
    if (!['http:', 'https:'].includes(urlObj.protocol)) {
      console.warn('[安全检查] URL 协议不允许:', urlObj.protocol);
      return false;
    }

    // 3. 获取 hostname 并进行白名单校验
    const hostname = urlObj.hostname.toLowerCase();

    // 4. 检查是否匹配白名单域名
    const isAllowed = ALLOWED_DOMAINS.some((domain) => {
      const domainPattern = domain.toLowerCase();

      // 处理通配符 *.example.com
      if (domainPattern.startsWith('*.')) {
        const baseDomain = domainPattern.slice(2); // 移除 *.
        // 匹配 example.com 或 xxx.example.com
        return hostname === baseDomain || hostname.endsWith('.' + baseDomain);
      }

      // 精确匹配
      return hostname === domainPattern;
    });

    if (!isAllowed) {
      console.warn('[安全检查] URL 域名不在白名单中:', hostname);
    }

    return isAllowed;
  } catch (error) {
    // URL 格式不正确
    console.error('[安全检查] URL 格式无效:', url, error);
    return false;
  }
};
